import { Icon } from '@factorialco/deprecated-design-system'

import { PaginatedTableItem } from 'modules/finance/components/FinancialWorkspace/types/table'

export const defaultItems = ({
  rows,
  columns,
  title,
  titleIcon,
  minRange = 10000,
  maxRange = 20000,
}: {
  title: string
  titleIcon?: React.ComponentProps<typeof Icon.Medium>['icon']
  rows: number
  columns: number
  minRange?: number
  maxRange?: number
}): PaginatedTableItem[] => {
  return [
    {
      id: 'default',
      label: title,
      iconLabel: titleIcon,
      data: Array.from({ length: columns }, () => ({
        label: 'Line',
        range: 'Range',
        totalAmountInCents: Math.round(Math.random() * (maxRange - minRange) + minRange).toString(),
        period: 'monthly',
      })),
      children: Array.from({ length: rows }, () => ({
        id: 'default',
        label: 'Line',
        data: Array.from({ length: columns }, () => ({
          label: 'Line',
          range: 'Range',
          totalAmountInCents: Math.round(
            Math.random() * (maxRange - minRange) + minRange
          ).toString(),
          period: 'monthly',
        })),
      })),
    },
  ]
}
